import {
  MinusCircleOutlined,
  PlusCircleOutlined,
  ShoppingCartOutlined,
} from "@ant-design/icons";
import { Avatar, Button, Divider, Flex } from "antd";
import { useMemo } from "react";
import { Sheet } from "react-modal-sheet";
import { useStoreContext } from "../providers/store.provider";
import { IProductOnline } from "../types/types";
import { capitalize, capitalizeFirst } from "../utils/functions";
import { toFixedDisplay } from "../utils/number.utils";

export default function ProductViewBottomSheet({
  open,
  onClose,
  product,
  productsToCheckout,
  onRemoveItems,
  onAddItems,
}: {
  onRemoveItems: (product: IProductOnline) => void;
  onAddItems: (product: IProductOnline) => void;
  product?: IProductOnline;
  open: boolean;
  onClose: () => void;
  productsToCheckout: IProductOnline[];
}) {
  const { currency } = useStoreContext();

  const productCountMap: Map<string, number> = useMemo(() => {
    const map = new Map<string, number>();
    for (const p of productsToCheckout) {
      const existing = map.get(p._id);
      if (existing) {
        map.set(p._id, existing + 1);
      } else {
        map.set(p._id, 1);
      }
    }
    return map;
  }, [productsToCheckout]);

  return (
    <Sheet isOpen={open} onClose={onClose}>
      <Sheet.Container style={{}}>
        <Sheet.Header />
        <Sheet.Content>
          <div className="flex items-center justify-center flex-col p-10">
            <div className="divCenterAlign">
              <Avatar src={product?.cover ?? ""} size={120} />
            </div>
            <div className="my-6">
              <h1 className="font-bold text-xl">
                {capitalize(product?.title)}
              </h1>
              <h3>
                {currency}
                {toFixedDisplay(product?.price.value)}
              </h3>
            </div>

            <Divider />

            <div>
              <p>{capitalizeFirst(product?.description)}</p>
            </div>

            {product && (
              <div className="my-10 flex w-full flex-col">
                {productsToCheckout
                  .map((p) => p._id)
                  .includes(product!._id) && (
                  <div className="flex justify-center gap-2 items-center">
                    <Button
                      icon={<MinusCircleOutlined style={{ fontSize: 20 }} />}
                      type="link"
                      onClick={() => onRemoveItems(product!)}
                    />
                    <Button
                      size="large"
                      icon={<ShoppingCartOutlined />}
                      style={{ color: "var(--exhut-blue)" }}
                    >
                      {productCountMap.get(product!._id)}
                    </Button>
                    <Button
                      icon={<PlusCircleOutlined style={{ fontSize: 20 }} />}
                      type="link"
                      onClick={() => onAddItems(product!)}
                    />
                  </div>
                )}
                {!productsToCheckout
                  .map((p) => p._id)
                  .includes(product!._id) && (
                  <button
                    className="px-4 py-2 text-white w-full flex rounded-lg items-center flex justify-center"
                    style={{
                      backgroundColor: "#1890ff", // Ant Design blue
                    }}
                    onClick={() => onAddItems(product!)}
                  >
                    Add To Cart
                  </button>
                )}
                <Flex vertical className="my-10">
                  <button
                    className="bg-gray-500 text-white rounded-lg px-4 py-2"
                    onClick={() => onClose()}
                  >
                    Close
                  </button>
                </Flex>
              </div>
            )}
          </div>
        </Sheet.Content>
      </Sheet.Container>
      <Sheet.Backdrop />
    </Sheet>
  );
}
